import React, {PureComponent} from 'react';

import {Callout, Classes, Overlay} from "@blueprintjs/core";
import {Link} from "react-router-dom";

export default class ViberSentModal extends PureComponent {

    state = {
        overlayIsOpen: false,
        contacts: this.props.contacts,
        costEstimate: this.props.costEstimate,
        listOfEuAbbreviations: ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
            'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'],
        country: this.props.country,
        newBalance: this.props.newBalance,
        topUpAmount: this.props.topUpAmount,
        topUpDisclaimer: this.props.topUpDisclaimer,
        availableCredit: this.props.availableCredit,
        availableWorkspaceCredit: this.props.availableWorkspaceCredits,
        newWorkspaceBalance: this.props.newWorkspaceBalance,
        paymentMessage: this.props.paymentMessage,
        vatPercent: this.props.vatPercent
    }

    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {

        this.setState({

            contacts: this.props.contacts,
            costEstimate: this.props.costEstimate

        })
        //console.log('number estimate1: ', this.state.costEstimate)
    }

    goToCampaignPerformance = () => {
        localStorage.removeItem('selected_main_type')
        this.props.handleClose()
        this.props.history.push('/my-campaigns/viber')
    }

    componentDidUpdate = async () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            await this.setState({
                overlayIsOpen: this.props.showModal,
                contacts: this.props.contacts,
                costEstimate: this.props.costEstimate
            })
            //console.log('number estimate2: ', this.state.costEstimate)

        }
        if (this.state.country !== this.props.country ||

            this.state.topUpAmount !== this.props.topUpAmount ||
            this.state.topUpDisclaimer !== this.props.topUpDisclaimer ||
            this.state.availableWorkspaceCredit !== this.props.availableWorkspaceCredits ||
            this.state.newWorkspaceBalance !== this.props.newWorkspaceBalance ||
            this.state.availableCredit !== this.props.availableCredit ||
            this.state.paymentMessage !== this.props.paymentMessage
        ) {

            await this.setState({
                country: this.props.country,
                topUpAmount: this.props.topUpAmount,
                topUpDisclaimer: this.props.topUpDisclaimer,
                availableCredit: this.props.availableCredit,
                availableWorkspaceCredit: this.props.availableWorkspaceCredits,
                newWorkspaceBalance: this.props.newWorkspaceBalance

            })
        }

        if (this.state.newBalance !== this.props.newBalance) {
            //console.log('new balance different')
            await this.setState({
                    newBalance: this.props.newBalance,

                }
            )
        }
        if (this.state.vatPercent !== this.props.vatPercent) {
            //console.log('vat percent different')
            await this.setState({
                vatPercent: this.props.vatPercent,

                }
            )
        }

    }

    setTestNumber = (e) => {
        this.setState({testNumber: e.target.value})
    }

    render() {
        let minimalEstimateCost
        let vatCountry = this.state.listOfEuAbbreviations.filter(country =>
            country === this.state.country)
        //console.log('vatCountry: ', vatCountry)
        if (vatCountry) {
            // console.log('vatCountry length: ', vatCountry.length);
        }

        if (vatCountry.length > 0 && this.state.country !== '') {
            //console.log('vat country length is not 0, it is: ', vatCountry.length)
            minimalEstimateCost = parseFloat(this.state.costEstimate * 1.2)
        } else {
            //console.log('vat country length is 0')
            minimalEstimateCost = parseFloat(this.state.costEstimate)
        }
        return (

            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={() => {
                        this.props.handleClose()
                    }}><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel post-reach">

                        <React.Fragment>
                            <p className=" modal-title text-center m-m-b" style={{fontSize: "30px"}}>
                                Your Viber campaign has been dispatched to:
                            </p>


                            <div className="section-content text-center ">
                                <p className="letter text-bold">
                                    {this.props.contacts}
                                    <br></br>
                                    <span>{this.props.contacts === 1 ? 'Contact' : 'Contacts'}</span>
                                </p>
                            </div>


                            {this.state.costEstimate ?
                                this.state.costEstimate === '0.0000' ?
                                    //FREE CASE
                                    <Callout className='estimate-cost-callout'>


                                        <span className='flex-row justify-content-space'>

                                            <div className='flex-row estimated-cost-container'>
                                                Estimated Cost:
                                            </div>
                                            <span className='cost-estimate-value cost-free'>FREE</span>

                                        </span>

                                    </Callout>
                                    :
                                    // NOT FREE CASE
                                    <React.Fragment>
                                        <Callout className='estimate-cost-callout viber-total-cost'>

                                            <span className='flex-row justify-content-space'>

                                                <div className='flex-row estimated-cost-container'>
                                                    Total Cost
                                                </div>

                                                <span
                                                    className='cost-estimate-value text-bold viber-cost-estimate-value text-bold'>


                                                    {this.state.costEstimate} credits

                                                </span>

                                            </span>
                                            <hr/>
                                            <span className='flex-row justify-content-space'>
                                                <div>
                                                    Available Viber Credits
                                                </div>
                                                <div>
                                                    {Number(this.state.availableCredit).toFixed(2)} credits
                                                </div>
                                            </span>
                                            {this.state.paymentMessage === ("Estimate larger than viber credits, will be deducted from workspace balance" && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0) || (this.state.paymentMessage === "Estimate larger than both viber and workspace credits, top up enabled, will be deducted from workspace balance" && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0) ?
                                                <span className='flex-row justify-content-space'>
                                                    <div>
                                                        Available Workspace Credits
                                                    </div>
                                                    <div>
                                                        {Number(this.state.availableWorkspaceCredit).toFixed(2)}

                                                    </div>
                                                </span>
                                                : ''
                                            }
                                            {/*{this.state.topUpAmount !== '' ?*/}
                                            {this.state.topUpAmount > 0 ?
                                                <span className='flex-row justify-content-space'>
                                                    <div className='top-up-text'>
                                                        Top-up Required
                                                    </div>
                                                    <div className='blue-text'>
                                                        $ {this.state.topUpAmount !== '' && this.state.topUpAmount > 0 ?
                                                        this.state.vatPercent !== 0 ?
                                                            <React.Fragment>
                                                                {Number(Number(this.state.topUpAmount)
                                                                    +
                                                                    Number((this.state.topUpAmount / 100) * this.state.vatPercent)).toFixed(2)}
                                                                <span className='vat-included'>(VAT
                                                                    included:
                                                                    ${Number((this.state.topUpAmount / 100) * this.state.vatPercent
                                                                    ).toFixed(2)})
                                                                </span>
                                                            </React.Fragment>
                                                            :
                                                            Number(this.state.topUpAmount).toFixed(2)

                                                        : '0.00'}
                                                    </div>
                                                </span>
                                                : ''
                                            }

                                        </Callout>

                                        {this.state.topUpDisclaimer ?
                                            <p className='text-right minimal-charge top-up-disclaimer'>
                                                Minimal top-up amount is $ 15.00
                                            </p>
                                            :
                                            ''
                                        }
                                        <div className='new-balance-viber-container'>
                                            <div
                                                className={
                                                    this.state.paymentMessage === "Estimate larger than viber credits, will be deducted from workspace balance" || (this.state.paymentMessage === "Estimate larger than both viber and workspace credits, top up enabled, will be deducted from workspace balance"
                                                        //    && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0
                                                    )
                                                        ?
                                                        'new-balance-viber border-bottom display-flex justify-content-space' :
                                                        'new-balance-viber display-flex justify-content-space'
                                                }>
                                                <span>
                                                    Remaining Viber Credit
                                                </span>
                                                <span>
                                                    {Number(this.state.newBalance).toFixed(2)} credits
                                                </span>
                                            </div>
                                            {
                                                this.state.paymentMessage === "Estimate larger than viber credits, will be deducted from workspace balance" || (this.state.paymentMessage === "Estimate larger than both viber and workspace credits, top up enabled, will be deducted from workspace balance"
                                                )

                                                    ?
                                                    <div
                                                        className='new-balance-workspace display-flex justify-content-space'>
                                                        <span>
                                                            Remaining Workspace Balance
                                                        </span>
                                                        <span>
                                                            {Number(this.state.newWorkspaceBalance).toFixed(2)} credits
                                                        </span>
                                                    </div>
                                                    : ''
                                            }
                                        </div>

                                        {this.state.topUpBalance ?
                                            <Callout intent='danger' className='margin-top-20'>
                                                You need to <Link to="/billing/balance">add credits to
                                                your workspace
                                                balance</Link> -
                                                No workspace balance set up
                                            </Callout>
                                            :
                                            ''
                                        }
                                    </React.Fragment>
                                :
                                ''
                            }
                        </React.Fragment>
                    </div>
                    <div className="m-lg-t flex-direction-row justify-content-space">
                        <button className='btn-white'
                                onClick={this.goToCampaignPerformance}>
                            Go to My Campaigns
                        </button>
                        <button className='btn-action'
                                onClick={() => {
                                    this.props.handleClose()
                                }}>
                            Start a new campaign
                        </button>
                    </div>
                </div>
            </Overlay>
        )
    }
}